import { action, payload } from 'ts-action'
import { IError, IPayload } from 'models/Global'
import { IShift } from 'models/Shift'
import { IShiftNote } from '@src/models/ShiftNote'

export const GetSelectedShift = action('GetSelectedShift', payload<IPayload<IShift>>())

export const UpdateSelectedShift = action(
  'UpdateSelectedShift',
  payload<{
    response: IPayload<IShift>
    shiftNotesResponse: IPayload<IShiftNote[]>
  }>()
)

export const AddShiftNote = action(
  'AddShiftNote',
  payload<{ note: IPayload<IShiftNote>; shiftId: number }>()
)

export const DeleteShiftNote = action(
  'DeleteShiftNote',
  payload<{ noteId: number; shiftId: number; isReply: boolean }>()
)

export const UpdateShiftNote = action('UpdateShiftNote', payload<{ id: number; note: string }>())

export const DeleteSelectedShift = action('DeleteSelectedShift')

export const SelectedShiftFetching = action('SelectedShiftFetching', payload<boolean>())

export const ResetSelectedShift = action('ResetSelectedShift')

export const GetSelectedShiftErrors = action('GetSelectedShiftErrors', payload<IError>())

export const PutSelectedShiftLock = action('PutSelectedShiftLock', payload<boolean>())
